import {
  REGISTER_DOCTOR_SUCCESS,
  REGISTER_DOCTOR_ERROR,
  SET_LOADING,
  LOGOUT,
  AUTH_ERROR,
  CLEAR_ERRORS,
} from '../../../types'

const initialState = {
  token: localStorage.getItem('token'),
  isAuthenticated: null,
  loading: false,
  doctor: {},
  msg: null,
  error: null,
}

type Action = {
  type: string
  payload: {
    token: string
    doctor: object
    message: string
  }
}

export const doctorRegister = (state = initialState, { type, payload }: Action) => {
  switch (type) {
    case SET_LOADING:
      return {
        ...state,
        loading: true,
      }

    case REGISTER_DOCTOR_SUCCESS:
      localStorage.setItem('token', payload.token)
      return {
        ...state,
        ...payload,
        isAuthenticated: true,
        doctor: payload.doctor,
        loading: false,
      }

    case REGISTER_DOCTOR_ERROR:
      return {
        ...state,
        token: null,
        isAuthenticated: null,
        doctor: {},
        error: payload.message ? payload.message : payload,
        loading: false,
      }

    case AUTH_ERROR:
    case LOGOUT:
      localStorage.removeItem('token')
      return {
        ...state,
        isAuthenticated: null,
        doctor: {},
        error: null,
        loading: false,
      }

    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
        loading: false,
      }

    default:
      return state
  }
}
